import axios        from 'axios';
import finallyBlock from 'promise.prototype.finally';
import Cookies      from 'js-cookie'

finallyBlock.shim();

axios.defaults.withCredentials = true;

axios.interceptors.response.use((response)=> (response), (error)=> {

  const rejection = error.response;

  if (rejection.status == 401 && rejection.data.error == 'Invalid session') {
    Cookies.remove('esid');
    Cookies.remove('uuid');
    window.localStorage.clear("currentUser");
    window.location.href= "/login";
  }

  if (rejection.status == 422 && rejection.data.error) {

    if(typeof rejection.data.error == 'string') {
      return Promise.reject({ generalError : rejection.data.error });
    }

    return Promise.reject(rejection.data.error);
  }
  return Promise.reject(error.response);
}
);
